export const formatTotalNumber = (num: number) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M+'
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'k+'
  }

  return num
}
